import { shape, string, number } from 'prop-types';
import isNil from 'lodash/isNil';
import { shortDateOf, shortDateTimeOf } from '@active/core/datetime';

const DateTime = ({
  date: {
    time,
    timeZoneOffset,
  } = {},
  locale = 'en_US',
  showShortDateOfTime = false,
}) => {
  const currentDate = !isNil(time) && !isNil(timeZoneOffset)
    ? new Date(time + timeZoneOffset).toISOString() : '';
  const formattedDateTimeMethod = !showShortDateOfTime ? shortDateOf(locale) : shortDateTimeOf(locale);
  return currentDate ? formattedDateTimeMethod(currentDate) : null;
};

DateTime.propTypes = {
  date: shape({
    time: number,
    timeZoneOffset: number,
  }),
  locale: string,
};

export default DateTime;
